import IDeviceInfo from "./IDeviceInfoHandler";
// import DeviceInfo from "react-native-device-info";
import { Dimensions, Platform } from "react-native";
import { isIPhoneX } from "react-native-status-bar-height";

export default class DeviceInfoHandler implements IDeviceInfo {
  constructor() {}

  isTablet(): boolean {
    var min = 600;
    let { width, height } = Dimensions.get("window");
    // console.log("Tablet mode Web-hight",height)
    // console.log("Tablet mode Web-Width",width)
    if (this.isLandscape()) return height >= min;
    return width >= min;
  }

  isLandscape(): boolean {
    let { width, height } = Dimensions.get("window");
    return width >= height;
  }
  isKioskMode(): boolean {
    return this.isTablet() && this.isLandscape();
  }
}
